import React from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import NotFound from 'pages/NotFound'
import AlertDescriptionForm from 'pages/shared/AlertDescriptionForm'

import { alertCodeDisplayValue, alertCodeRawValue } from 'helpers/alerts'

import { useStoreContext } from 'hooks/StoreContext'
import useAlertDescriptions from 'hooks/useAlertDescriptions'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditAlertDescription = () => {
  useAlertDescriptions()

  const { alertCode: alertCodeFromUrl } = useParams()

  const { alertDescriptions, areAlertDescriptionsLoaded } = useStoreContext()

  if (!areAlertDescriptionsLoaded) {
    return <LoadingSinglePanePage />
  }

  const alertDescription = alertDescriptions?.filter(
    (alert) => alert.code?.toUpperCase() === alertCodeRawValue(alertCodeFromUrl).toUpperCase()
  )[0]

  if (!alertDescription) {
    return <NotFound />
  }

  const alertDescriptionWithDisplayCode = {
    ...alertDescription,
    code: alertCodeDisplayValue(alertDescription.code)
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Alert: {alertDescriptionWithDisplayCode.code}</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <AlertDescriptionForm
          alertDescription={alertDescriptionWithDisplayCode}
          saveMethod="update"
          displayDeleteButton
        />
      </S.SinglePanePage>
    </>
  )
}

export default EditAlertDescription

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
